import React from "react";
import { VelocityScroll } from "./VelocityScroll";

export function ScrollBasedVelocityDemo() {
  return (
    <VelocityScroll
      text="⚡❤️Speed Meets Health&nbsp;&nbsp;&nbsp;&nbsp; 🚚💨Fast Delivery&nbsp;&nbsp;&nbsp;&nbsp; 📋✔️Customized Meal Plans&nbsp;&nbsp;&nbsp;&nbsp;📱🛒Easy Ordering&nbsp;&nbsp;&nbsp;&nbsp;🍎🎓Nutritional Expertise&nbsp;&nbsp;&nbsp;&nbsp;"
      default_velocity={1}
      className="font-display text-center text-xl font-bold tracking-[-0.02em] text-[#131313] drop-shadow-sm dark:text-white md:text-xl md:leading-[2rem] bg-[#ff745d] py-[5px] "
    />
  );
}
